/* Core & libraries */
import React, { useState, useEffect } from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { useUserContext } from "../../contexts/userContext";

/* Components */

/* Styles */
import styles from "./styles.js";

const Login = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  const userContext = useUserContext();
  const providerCode = userContext?.userInfo?.providerInfo?.providerCode;

  const [LoginComponent, setLoginComponent] = useState(null);

  useEffect(() => {
    import(`../../components/login/${providerCode}`)
      .then((component) => {
        setLoginComponent(() => component.default);
      })
      .catch((error) => {
        console.error("Error loading component", error);
      });
  }, [providerCode]);

  return <>{LoginComponent && <LoginComponent />}</>;
};

export default Login;
